var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3668 1.40927L6.03345 3.69075C4.83975 3.98255 4 5.0523 4 6.28115V17.6171C4 22.1047 6.55655 26.2003 10.5881 28.1714L15.4144 30.5309C15.5992 30.6211 15.7996 30.6663 16 30.6663C16.2004 30.6663 16.4008 30.6211 16.5856 30.5309L21.4119 28.1714C25.4435 26.2003 28 22.1047 28 17.6171V6.28115C28 5.0523 27.1603 3.98255 25.9665 3.69075L16.6332 1.40927C16.4252 1.35843 16.2127 1.33301 16 1.33301C15.7873 1.33301 15.5748 1.35843 15.3668 1.40927ZM21.3333 14.6663C21.3333 13.9299 20.7364 13.333 20 13.333V11.9997C20 9.79054 18.2092 7.99967 16 7.99967C13.7908 7.99967 12 9.79054 12 11.9997V13.333C11.2636 13.333 10.6667 13.9299 10.6667 14.6663V18.6663C10.6667 19.4027 11.2636 19.9997 12 19.9997H20C20.7364 19.9997 21.3333 19.4027 21.3333 18.6663V14.6663ZM16 10.6663C15.2636 10.6663 14.6667 11.2633 14.6667 11.9997V13.333H17.3333V11.9997C17.3333 11.2633 16.7364 10.6663 16 10.6663Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.9efbb44054f4eb3b0f825feb6f57b4ec.svg";
export { ForwardRef as ReactComponent };